<template>
  <section class="home-block">
    <div ref="content" class="content">
      <div class="container">
        <div ref="title" class="title h1">Ваше новое окружение</div>
      </div>
      <ProjectInfrastructureMap />
    </div>
  </section>
</template>

<script>
import ProjectInfrastructureMap from "@/components/home/ProjectInfrastructureMap.vue";
import { gsap } from "gsap";
import { is_touch } from "@/helpers.js";
export default {
  components: {
    ProjectInfrastructureMap,
  },
  data() {
    return {
      activeTab: "Map",
    };
  },
  computed: {
    currentTabComponent() {
      return "Road" + this.activeTab;
    },
  },
  mounted() {
    if (!is_touch()) {
      gsap.from(gsap.utils.toArray([this.$refs.title]), {
        y: 150,
        stagger: { each: 0.1 },
        scrollTrigger: {
          trigger: this.$refs.content,
          start: "top bottom",
          end: "70% center",
          scrub: 1.5,
        },
      });
    }
  },
};
</script>

<style scoped>
.content {
  position: relative;
}

.title {
  position: relative;
  z-index: 2;
  margin-bottom: 57px;
  text-align: center;
}

.h1 {
  font-size: 72px;
}

@media (max-width: 767px) {
  .title {
    margin-bottom: 27px;
  }

  .h1 {
    font-size: 36px;
  }
}
</style>
